/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
export default typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/utils/esm/ponyfillGlobal.js
// module id = 1738
// module chunks = 121